// extracted by mini-css-extract-plugin
export default {"usersignup":"UserSignUp_usersignup__SGd5U"};